import styled from 'styled-components'
import LiveData from '../Items/LiveData';
import { useEffect, useState } from 'react';
import { getCalibration } from '../../server';

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  width: 95%;
`

const CenterContainer = styled.div`
  text-align: start;
  margin: auto;
  width: 600px;
  max-width: 100%;
`

export default function WECs({ wec, messages }) {
  const [calibration, setCalibration] = useState(null)

  useEffect(() => {
    if (wec && wec.hostname) {
      getCalibration(wec.hostname).then(calibration => {
        setCalibration(calibration)
        console.log(`Calibration data for ${wec.hostname}:`, calibration)
      }).catch(error => {
        console.error('Error fetching calibration data:', error)
      })
    }
  }, [wec])

  if (!wec)
    return <div />

  const name = wec.name || wec.hostname || wec.id
  const isOnline = messages?.status?.status?.connected
  const title = isOnline === true
    ? `${name} is online`
    : isOnline === false
      ? `${name} is offline`
      : name

  return (
    <FlexContainer>
      <CenterContainer>
        <h1>{title}</h1>
        <LiveData messages={messages} isOnline={isOnline} calibration={calibration} />
      </CenterContainer>
    </FlexContainer>
  )
}
